// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Kz9j","colCheckbox":"styles_colCheckbox__3ohOR"};